import { createContext, ReactNode, useContext, useState } from "react";
import { PropertiesTypes } from "./interface.utils";

interface IPropertiesTypeContext {
    propertiesType:string;
    setPropertiesType: (type:string) => void;
}

const PropertiesTypeContext = createContext<IPropertiesTypeContext>({
    propertiesType: PropertiesTypes.TARGET,
    setPropertiesType: () => {}
});

const usePropertiesTypeContext = () => {
    const context = useContext(PropertiesTypeContext)
    if(!context) {
        throw new Error("usePropertiesTypeContext must be used within a PropertiesTypeContext")
    }
    return context
}

interface IPropertiesTypeProvider {
    children: ReactNode,
}


const PropertiesTypeProvider = (props:IPropertiesTypeProvider) => {
    const [propertiesType, setPropertiesType] = useState<string>(PropertiesTypes.TARGET);
    return (
        <PropertiesTypeContext.Provider value={{propertiesType, setPropertiesType}}>
            {props.children}
        </PropertiesTypeContext.Provider>
    )
}

export {PropertiesTypeProvider, usePropertiesTypeContext}
export default PropertiesTypeContext;
